var _regeneratorRuntime = require("/home/ben/workspace/showhow.v2/src/main/app/node_modules/react-scripts-ts/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/home/ben/workspace/showhow.v2/src/main/app/node_modules/react-scripts-ts/node_modules/@babel/runtime/helpers/asyncToGenerator");

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var egm96 = require('egm96-universal');

var breathe = require('./utils/breathe'); //Adapts WGS84 ellipsoid heights in GPS data to EGM96 geoid (closer to mean sea level) and filters out bad gps data


module.exports = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(klv, _ref) {
    var ellipsoid, GPS5Precision, GPS5Fix, geoidHeight, approveStream, result, correction, _iterator, _step, d, length, i, fixQuality, precision, centered, rating, scaling;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            ellipsoid = _ref.ellipsoid, GPS5Precision = _ref.GPS5Precision, GPS5Fix = _ref.GPS5Fix, geoidHeight = _ref.geoidHeight;

            //Set conditions to filter out GPS5 by precision and type of fix
            approveStream = function approveStream(s) {
              if (GPS5Fix != null) {
                if (s.GPSF == null) return false;
                if (s.GPSF < GPS5Fix) return false;
              }

              if (GPS5Precision != null) {
                if (s.GPSP == null) return false;
                if (s.GPSP > GPS5Precision) return false;
              }

              return true;
            }; //Copy the klv data


            try {
              result = JSON.parse(JSON.stringify(klv));
            } catch (error) {
              result = klv;
            } //Store best correction value


            correction = {}; //Loop through packets of samples if correction or filtering needed
            //If GPX, we need height compensation either way

            if (!(!ellipsoid || geoidHeight || GPS5Fix != null || GPS5Precision != null)) {
              _context.next = 30;
              break;
            }

            _iterator = _createForOfIteratorHelper(result.DEVC || []);
            _context.prev = 6;

            _iterator.s();

          case 8:
            if ((_step = _iterator.n()).done) {
              _context.next = 21;
              break;
            }

            d = _step.value;
            length = result.DEVC.length; //First loop to find a suitable value

            i = ((d || {}).STRM || []).length - 1;

          case 12:
            if (!(i >= 0)) {
              _context.next = 19;
              break;
            }

            _context.next = 15;
            return breathe();

          case 15:
            //Mark for deletion streams that do not pass the test, but keep them for possible timing
            if (d.STRM[i].GPS5 && !approveStream(d.STRM[i])) d.STRM[i].toDelete = true;else if ( //If altitude is mean sea level, no need to process it further
            //Otherwise check if all needed info is available
            d.STRM[i].GPSA !== 'MSLV' && (!ellipsoid || geoidHeight) && d.STRM[i].GPSF != null && d.STRM[i].GPSP != null && d.STRM[i].GPS5 && d.STRM[i].GPS5[0] != null) {
              // Analyse quality of GPS data, and how centered in the dataset time it is
              fixQuality = d.STRM[i].GPSF / 3;
              precision = (9999 - d.STRM[i].GPSP) / 9999;
              centered = (length / 2 - Math.abs(length / 2 - i)) / (length / 2); //Arbitrary weight for each factor

              rating = fixQuality * 10 + precision * 20 + centered; //Pick the best quality correction data

              if (correction.rating == null || rating > correction.rating) {
                //Use latitude and longitude to find the altitude offset in this location
                correction.rating = rating;
                scaling = d.STRM[i].SCAL && d.STRM[i].SCAL.length > 1 ? [d.STRM[i].SCAL[0], d.STRM[i].SCAL[1]] : [1, 1];
                correction.source = [d.STRM[i].GPS5[0][0] / scaling[0], d.STRM[i].GPS5[0][1] / scaling[1]];
              }
            }

          case 16:
            i--;
            _context.next = 12;
            break;

          case 19:
            _context.next = 8;
            break;

          case 21:
            _context.next = 26;
            break;

          case 23:
            _context.prev = 23;
            _context.t0 = _context["catch"](6);

            _iterator.e(_context.t0);

          case 26:
            _context.prev = 26;

            _iterator.f();

            return _context.finish(26);

          case 29:
            if (correction.source) correction.value = egm96.meanSeaLevel(correction.source[0], correction.source[1]);

          case 30:
            if (correction.value != null) {
              //Loop streams to make the height adjustments
              (result.DEVC || []).forEach(function (d) {
                ((d || {}).STRM || []).forEach(function (s) {
                  //Find GPS data
                  if (s.GPS5) {
                    if (!ellipsoid) s.altitudeFix = correction.value;else s.geoidHeight = correction.value;
                  }
                });
              });
            }

            return _context.abrupt("return", result);

          case 32:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[6, 23, 26, 29]]);
  }));

  return function (_x, _x2) {
    return _ref2.apply(this, arguments);
  };
}();